module.exports = __webpack_public_path__ + "img/twitter.a688959c.svg";